import { HTMLAttributes } from 'react';
import Lottie from 'lottie-react';

import { cardContainer, contentWrapper, annotationWrapper, annotation } from './_card.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
    title: string;
    description: string;
    animation: string;
    isVisible: boolean;
    index: number;
    handleAnimationEnding: (index: number) => void;
    className?: string;
}

export const Card = ({
    title,
    description,
    animation,
    className,
    isVisible,
    index,
    handleAnimationEnding,
    ...rest
}: Props) => {
    return (
        <div
            className={`${cardContainer} ${className}`}
            style={{ opacity: isVisible ? 1 : 0, transition: 'opacity 220ms ease-in-out' }}
            {...rest}>
            <div className={annotationWrapper}>
                {index === 0 && (
                    <Lottie
                        className={annotation}
                        animationData={animation}
                        loop={false}
                        onComplete={() => handleAnimationEnding(index)}
                    />
                )}{' '}
                {index === 1 && (
                    <Lottie
                        className={annotation}
                        animationData={animation}
                        loop={false}
                        onComplete={() => handleAnimationEnding(index)}
                    />
                )}
            </div>

            <div className={contentWrapper}>
                <h4>{title}</h4>
                <p>{description}</p>
            </div>
        </div>
    );
};
